export const MENU = [
  {
    id: "hamburgers",
    label: "Hamburgers",
    note: "Tutti gli hamburger sono accompagnati da un contorno a scelta tra patatine fritte*, insalata verde, insalata mista e verdure grigliate. Si possono ordinare anche senza contorno e/o al piatto.",
    items: [
      { id: "hamburger-classico", name: "L'Hamburger 130g", desc: "Panino, lattuga, carne, pomodoro, contorno a scelta", price: "9,00" },
      { id: "cheeseburger", name: "Il Cheeseburger 130g", desc: "Panino, lattuga, carne, formaggio, pomodoro, contorno a scelta", price: "9,50" },
      { id: "baconburger", name: "Il Baconburger 130g", desc: "Panino, lattuga, carne, formaggio, bacon, pomodoro, contorno a scelta", price: "10,50" },
      { id: "hamburger-teresina", name: "L'Hamburger Teresina 130g", desc: "Panino, lattuga, carne, formaggio, cipolla, prosciutto cotto, pomodoro, contorno a scelta", price: "10,50", tag: "Il nostro" },
      { id: "hamburger-occhio-di-bue", name: "L'Hamburger all'Occhio di Bue 130g", desc: "Panino, lattuga, pomodoro, carne, formaggio, uovo all'occhio di bue, contorno a scelta", price: "10,50" },
      { id: "hamburger-bufalina", name: "L'Hamburger Bufalina 130g", desc: "Panino, lattuga, carne, mozzarella di bufala, pomodoro, prosciutto crudo, contorno a scelta", price: "12,00" },
      { id: "doppio-hamburger", name: "Doppio Hamburger 260g", desc: "Panino, lattuga, pomodoro, doppia carne, prosciutto cotto, bacon, cheddar, cipolla, salsa della casa, contorno a scelta", price: "16,00", tag: "XXL" },
      { id: "chicken-burger", name: "Chicken Burger", desc: "Panino, lattuga, petto di pollo alla griglia, pomodoro, contorno a scelta", price: "10,50" },
      { id: "hamburger-vegetariano", name: "L'Hamburger Vegetariano", desc: "Panino, lattuga, hamburger vegetariano, pomodorini confit, formaggio, contorno a scelta", price: "9,50", tag: "Veg" },
      { id: "salmonburger", name: "Salmonburger", desc: "Panino, salmone affumicato, salsa allo yogurt, menta e lime, avocado, insalata songino, pomodorini confit, semi di papavero, contorno a scelta", price: "12,00" },
    ],
  },
  {
    id: "carni",
    label: "Le Carni",
    note: "Le nostre carni sono accompagnate da un contorno a scelta tra patatine fritte*, insalata verde, insalata mista e verdure grigliate.",
    items: [
      { id: "tagliata-fassona", name: "Tagliata di Fassona", price: "16,00", tag: "Piemontese" },
      { id: "petto-di-pollo", name: "Petto di Pollo", price: "15,00" },
      { id: "girello-salsiccia", name: "Girello di Salsiccia", price: "15,00" },
      { id: "wurstel", name: "Wurstel", price: "12,00" },
    ],
  },
  {
    id: "insalate",
    label: "Le Insalate",
    items: [
      { id: "insalatona-tonno", name: "Insalatona con Tonno", desc: "Pomodorini, uovo sodo, misticanza, carote à la julienne, olive taggiasche, mozzarella", price: "12,00" },
      { id: "insalatona-pollo", name: "Insalatona con Petto di Pollo", desc: "Mandorle tostate, misticanza, carote à la julienne, mela, olive taggiasche, scaglie di parmigiano", price: "12,00" },
      { id: "insalata-vitello", name: "Insalata con Straccetti di Vitello Marinati", desc: "Misticanza, frutta fresca di stagione, cialda croccante con quenelle di ricotta", price: "12,00" },
    ],
  },
  {
    id: "stuzzicherie",
    label: "Stuzzicherie",
    items: [
      { id: "crocchette-pollo", name: "Crocchette di Pollo", desc: "Di nostra produzione", price: "7,00" },
      { id: "patatine-fritte", name: "Patatine Fritte *", price: "5,00" },
      { id: "bruschette-mix", name: "Bruschette Mix", price: "10,00" },
      { id: "tagliere-misto", name: "Tagliere Misto", price: "15,00" },
    ],
  },
  {
    id: "piadine",
    label: "Le Piadine",
    items: [
      { id: "piadina-cotto", name: "Piadina Prosciutto Cotto e Formaggio", price: "6,00" },
      { id: "piadina-crudo", name: "Piadina Prosciutto Crudo e Formaggio", price: "7,00" },
      { id: "piadina-bresaola", name: "Piadina Bresaola, Lattuga e Pomodoro", price: "7,00" },
    ],
  },
  {
    id: "tacos",
    label: "Tacos Francesi",
    special: true,
    items: [],
  },
  {
    id: "bevande",
    label: "Bevande",
    items: [
      { id: "kozel", name: "Kozel Lager 5,0% vol", desc: "Birra alla spina", variants: [{ label: "Piccola", price: "4,00" }, { label: "Media", price: "6,00" }, { label: "Litro", price: "12,00" }] },
      { id: "san-benoit-ambre", name: "San Benoit Ambrè 6,6% vol", desc: "Birra alla spina", variants: [{ label: "Piccola", price: "4,00" }, { label: "Media", price: "6,00" }, { label: "Litro", price: "12,00" }] },
      { id: "san-benoit-triple", name: "San Benoit Triple 8,0% vol", desc: "Birra alla spina", variants: [{ label: "Piccola", price: "4,50" }, { label: "Media", price: "7,00" }, { label: "Litro", price: "15,00" }] },
      { id: "birre-bottiglia-1", name: "Bud, Heineken, Ichnusa, Beck's, Menabrea", price: "4,00" },
      { id: "birre-bottiglia-2", name: "Corona, Desperados, Guinness", price: "4,50" },
      { id: "birre-bottiglia-3", name: "Ceres, Tennent's, Paulaner, Ichnusa non filtrata", price: "4,50" },
      { id: "birre-speciali", name: "Birre in bottiglia speciali", price: "6,00" },
      { id: "vino-calice", name: "Vino al calice", price: "5,00" },
      { id: "acqua-050", name: "Acqua 0,5 L", price: "1,50" },
      { id: "acqua-075", name: "Acqua 0,75 L", price: "2,00" },
      { id: "bibite-lattina", name: "Bibite in lattina", price: "3,00" },
      { id: "bibite-vetro", name: "Bibite in bottiglietta di vetro", price: "3,50" },
      { id: "red-bull", name: "Red Bull", price: "3,50" },
      { id: "chinotto", name: "Chinotto Lurisia", price: "4,00" },
      { id: "succhi", name: "Succhi di frutta", price: "4,00" },
      { id: "ginger-beer", name: "Ginger Beer", price: "4,00" },
      { id: "ginger-ale", name: "Ginger Ale", price: "4,00" },
      { id: "crodino", name: "Crodino", price: "4,00" },
      { id: "cocktail-analcolico", name: "Cocktail analcolico", price: "6,00" },
      { id: "caffe", name: "Caffè", price: "1,50" },
      { id: "the-tisane", name: "Thè caldo / Tisane", price: "3,00" },
    ],
  },
  {
    id: "cocktails",
    label: "I Cocktails",
    note: "* I cocktail a base di gin, rum e whiskey speciali possono subire una maggiorazione di prezzo.",
    items: [
      { id: "mojito", name: "Mojito", desc: "Rum, zucchero di canna, lime, foglie di menta, soda", price: "6,00" },
      { id: "power-mojito", name: "Power Mojito", desc: "Rum, zucchero di canna, lime, foglie di menta, Red Bull", price: "6,00" },
      { id: "rum-cooler", name: "Rum Cooler", desc: "Rum bianco, zucchero di canna, lime, arancia, ginger ale", price: "6,00" },
      { id: "cubano", name: "Cubano", desc: "Rum, zucchero di canna, lime, foglie di menta, coca cola", price: "6,00" },
      { id: "caipirinha", name: "Caipirinha", desc: "Cachaça, lime, zucchero di canna (anche alla fragola)", price: "6,00" },
      { id: "caipiroska", name: "Caipiroska", desc: "Vodka, lime, zucchero di canna (anche alla fragola, pesca, cocco, kiwi)", price: "6,00" },
      { id: "caipirissima", name: "Caipirissima", desc: "Rum bianco, zucchero di canna (anche alla fragola, pesca, cocco, kiwi)", price: "6,00" },
      { id: "martini-cocktail", name: "Martini Cocktail", desc: "Gin, vermouth dry, oliva verde, fettina di limone", price: "6,00" },
      { id: "margarita", name: "Margarita", desc: "Tequila, cointreau, lime, sale a bordo bicchiere", price: "6,00" },
      { id: "negroni", name: "Negroni", desc: "Gin, vermouth rosso, bitter", price: "6,00" },
      { id: "daiquiri", name: "Daiquiri", desc: "Rum bianco, lime, sciroppo di zucchero", price: "6,00" },
      { id: "americano", name: "Americano", desc: "Vermouth rosso, bitter, soda", price: "6,00" },
      { id: "bloody-mary", name: "Bloody Mary", desc: "Vodka, succo di pomodoro, worcester, limone, tabasco, sale, pepe", price: "6,00" },
      { id: "manhattan", name: "Manhattan", desc: "Vermouth rosso, whiskey, angostura", price: "6,00" },
      { id: "cosmopolitan", name: "Cosmopolitan", desc: "Vodka, cointreau, succo di cranberry, succo di lime", price: "6,00" },
      { id: "japanese-slipper", name: "Japanese Slipper", desc: "Midori, triple sec, succo di limone, lemonsoda", price: "6,00" },
      { id: "sex-on-the-beach", name: "Sex on the Beach", desc: "Vodka, liquore alla pesca, succo d'arancia, succo di cranberry", price: "6,00" },
      { id: "gin-fizz", name: "Gin Fizz", desc: "Gin, succo di limone, sciroppo di zucchero, soda", price: "6,00" },
      { id: "pina-colada", name: "Piña Colada", desc: "Rum bianco, succo d'ananas, crema di cocco, panna fresca", price: "6,00" },
      { id: "tequila-sunrise", name: "Tequila Sunrise", desc: "Tequila, succo d'arancia, granatina", price: "6,00" },
      { id: "long-island", name: "Long Island", desc: "Rum bianco, vodka, gin, triple sec, zucchero, limone, coca cola", price: "6,00" },
      { id: "mai-tai", name: "Mai Tai", desc: "Rum bianco, rum scuro, triple sec, orzata, lime", price: "6,00" },
      { id: "old-fashioned", name: "Old Fashioned", desc: "Zolletta di zucchero, angostura, soda, whiskey, arancia, limone", price: "6,00" },
      { id: "white-russian", name: "White Russian", desc: "Vodka, kahlua, panna", price: "6,00" },
      { id: "black-russian", name: "Black Russian", desc: "Vodka, kahlua", price: "6,00" },
      { id: "spritz", name: "Spritz", desc: "Aperol, prosecco, soda", price: "6,00" },
      { id: "pina-on-the-beach", name: "Piña on the Beach", desc: "Rum, vodka, batida, peachtree, granatina, succo ananas", price: "6,00" },
      { id: "mass-gainer", name: "Mass Gainer", desc: "Bicerin, panna, gin", price: "6,00" },
      { id: "whiskey-sour", name: "Whiskey Sour", desc: "Bourbon whiskey, succo di limone, sciroppo di zucchero", price: "6,00" },
      { id: "screwdriver", name: "Screwdriver", desc: "Vodka, succo d'arancia", price: "6,00" },
      { id: "hulk", name: "Hulk", desc: "Malibu, midori, succo lime, lemonsoda, blue curacao", price: "6,00" },
      { id: "bronx", name: "Bronx", desc: "Gin, vermouth rosso, vermouth dry, succo d'arancia", price: "6,00" },
      { id: "moscow-mule", name: "Moscow Mule", desc: "Vodka, succo di lime, sciroppo di zucchero, ginger beer", price: "7,00" },
      { id: "analcolico-frutta", name: "Analcolico alla Frutta", desc: "Cocktail analcolico base", price: "6,00", tag: "Analcolico" },
      { id: "alcolico-frutta", name: "Alcolico alla Frutta", desc: "Cocktail alcolico base", price: "6,00" },
    ],
  },
  {
    id: "vini",
    label: "Il Vino",
    items: [
      { id: "tasmorcan", name: "Tasmorcan — Elio Perrone", desc: "Barbera d'Asti DOCG, 14,5% vol", price: "20,00", group: "Rossi" },
      { id: "carbune", name: "Carbunè — Franco Roero", desc: "Barbera d'Asti DOCG, 15% vol", price: "25,00", group: "Rossi" },
      { id: "santevasio-barbera", name: "Sant'Evasio — Sant'Evasio", desc: "Barbera d'Asti DOCG, 15% vol", price: "25,00", group: "Rossi" },
      { id: "tramonto", name: "Tramonto — Sant'Evasio", desc: "Monferrato Rosso DOC, 15% vol", price: "30,00", group: "Rossi" },
      { id: "rosignolo", name: "Rosignolo — Sant'Evasio", desc: "Barbera d'Asti Superiore DOCG, 15% vol", price: "30,00", group: "Rossi" },
      { id: "luna-falo", name: "Luna e i Falò — Vite Colte", desc: "Barbera d'Asti Superiore DOCG, 14,5% vol", price: "30,00", group: "Rossi" },
      { id: "nuble", name: "Nublè — Lo Zoccolaio", desc: "Nebbiolo DOC, 14% vol", price: "30,00", group: "Rossi" },
      { id: "nizza", name: "Nizza — Avezza", desc: "Nizza DOCG, 14,5% vol", price: "35,00", group: "Rossi" },
      { id: "barolo", name: "Barolo — Massara", desc: "Barolo DOCG, 14,5% vol", price: "45,00", group: "Rossi" },
      { id: "franco-roero-chardonnay", name: "Franco Roero", desc: "Piemonte Chardonnay DOC, 14% vol", price: "25,00", group: "Bianchi" },
      { id: "villa-sparina", name: "Villa Sparina", desc: "Gavi DOCG, 13% vol", price: "35,00", group: "Bianchi" },
      { id: "sanlisie", name: "Sanlisie — Marsaglia", desc: "Roero Arneis DOCG, 13% vol", price: "25,00", group: "Bianchi" },
      { id: "tra-donne-sole", name: "Tra Donne Sole — Vite Colte", desc: "Sauvignon DOC, 14% vol", price: "25,00", group: "Bianchi" },
      { id: "duebolle", name: "Duebolle — Sant'Evasio", desc: "Brut metodo Charmat, 13% vol", price: "20,00", group: "Bolle & Moscati" },
      { id: "alta-langa-se", name: "Alta Langa — Sant'Evasio", desc: "Alta Langa DOCG, 12% vol", price: "30,00", group: "Bolle & Moscati" },
      { id: "moscato-asti", name: "Moscato d'Asti — Sant'Evasio", desc: "Moscato d'Asti DOCG, 5% vol", price: "20,00", group: "Bolle & Moscati" },
      { id: "alta-langa-rose", name: "Alta Langa Rosé — Elèm", desc: "Alta Langa DOCG, 12% vol", price: "35,00", group: "Bolle & Moscati" },
      { id: "alta-langa-avezza", name: "Alta Langa — Avezza", desc: "Alta Langa DOCG, 12,5% vol", price: "35,00", group: "Bolle & Moscati" },
      { id: "r021-lallier", name: "R021 — Lallier", desc: "Champagne, 12,5% vol", price: "60,00", group: "Bolle & Moscati" },
    ],
  },
  {
    id: "altro",
    label: "Amari & Spirits",
    items: [
      { id: "amari", name: "Amari", price: "4,00" },
      { id: "amaro-berta", name: "Amaro di Berta", price: "6,00" },
      { id: "chivas", name: "Chivas Regal", price: "6,00" },
      { id: "four-roses", name: "Four Roses", price: "6,00" },
      { id: "jameson", name: "Jameson", price: "6,00" },
      { id: "jack-daniels", name: "Jack Daniel's", price: "6,00" },
      { id: "jack-miele", name: "Jack Daniel's Miele", price: "7,00" },
      { id: "jb", name: "J & B", price: "6,00" },
      { id: "lagavulin", name: "Lagavulin", price: "10,00" },
      { id: "laphroaig", name: "Laphroaig", price: "10,00" },
      { id: "caol-ila", name: "Caol Ila", price: "10,00" },
      { id: "oban", name: "Oban", price: "10,00" },
      { id: "zacapa", name: "Zacapa", price: "12,00" },
      { id: "grappe", name: "Grappe", price: "5,00" },
      { id: "grappe-speciali", name: "Grappe speciali", price: "8,00" },
      { id: "cocktails-speciali", name: "Cocktails speciali", price: "da 8,00 a 10,00" },
    ],
  },
];

export const TACOS_IMG = "/tacos.webp";
